import { newsfeedWidgetSizes } from "../WidgetAdd/utils/widgetSizes/newsfeedWidgetSizes";
import { WidgetPos } from "../types";

export function sizeToWidthAndHeight(
  size: "ONE_X_ONE" | "TWO_X_ONE" | "TWO_X_TWO" | "TWO_X_THREE" | "TWO_X_FOUR"
): { w: number; h: number } {
  switch (size) {
    case "ONE_X_ONE":
      return { w: 1, h: 1 };
    case "TWO_X_ONE":
      return { w: 2, h: 1 };
    case "TWO_X_TWO":
      return { w: 2, h: 2 };
    case "TWO_X_THREE":
      return { w: 2, h: 3 };
    case "TWO_X_FOUR":
      return { w: 2, h: 4 };
  }

  throw new Error("sizeToWidthAndHeight: did not find size " + size);
}

const overviewSizes = (
  ["TWO_X_ONE", "TWO_X_TWO", "TWO_X_THREE", "TWO_X_FOUR"] as const
).map(sizeToWidthAndHeight);

const noteSizes = (["TWO_X_TWO", "TWO_X_ONE"] as const).map(
  sizeToWidthAndHeight
);
const taskSizes = (["TWO_X_ONE", "ONE_X_ONE"] as const).map(
  sizeToWidthAndHeight
);

const weather = (["ONE_X_ONE", "TWO_X_ONE"] as const).map(sizeToWidthAndHeight);
const taskCollectionSizes = [{ w: 2, h: 1 }];
const turnpikeSizes = [
  { w: 2, h: 1 },
  { w: 2, h: 2 },
];
const routinePositivePercentageSizes = taskCollectionSizes;

export function getWidgetSizeWorklet(
  widget:
    | {
        kind: WidgetPos["kind"];
      }
    | null
    | undefined
): { w: number; h: number }[] {
  "worklet";
  if (!widget) {
    return [];
  }
  switch (widget.kind) {
    case "WidgetFile":
    case "WidgetIntegrationFlourishPraise":
    case "WidgetIssueSummary":
    case "WidgetEmployeeSchedule":
    case "WidgetEmployeeLeave":
    case "WidgetIntegrationPushAppy":
    case "WidgetRoutineOverview":
    case "WidgetSignalOverview":
    case "WidgetEmployeeRoleOverview":
    case "WidgetTodoOverview":
    case "WidgetTodoSummary":
    case "WidgetIssueOverview":
    case "WidgetIntegrationIpool":
    case "WidgetTeamSchedule":
    case "WidgetCalendarOverview":
    case "WidgetCalendar":
    case "WidgetKPI":
    case "WidgetList":
    case "WidgetTable":
      return overviewSizes;
    case "WidgetNote":
      return noteSizes;
    case "WidgetTaskSingle":
      return taskSizes;
    case "WidgetRoutinePositivePercentage":
      return routinePositivePercentageSizes;
    case "WidgetTaskCollection":
    case "WidgetTaskMultiple":
      return taskCollectionSizes;
    case "WidgetIntegrationTurnpike":
      return turnpikeSizes;
    case "WidgetWeather":
      return weather;
    case "WidgetSpace":
      return [];
    case "WidgetNewsfeed":
      return newsfeedWidgetSizes;
  }
  throw new Error();
}
